import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { BookingHistoryType } from "../../types/General";

interface CutomerBookingTableProps {
  isPast?: boolean;
  bookingData?: BookingHistoryType[];
}

const CutomerBookingTable = ({ bookingData }: CutomerBookingTableProps) => {
  const navigate = useNavigate();
  return (
    <div className="table_container">
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th>Booking ID</th>
            <th>Client Name</th>
            <th>Guests</th>
            <th>Internal Status</th>
            <th>Employee Name</th>
            <th>User Type</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          {bookingData?.length ? (
            bookingData?.map((row) => (
              <React.Fragment key={row.id}>
                <tr>
                  <td
                    className="cursor_p"
                    onClick={() =>
                      navigate(
                        `/manage-booking-resvp/booking-detail/${row?.id}`,
                        {
                          state: {
                            count: row?.totalGuest,
                            internalStatus: row?.internalStatus,
                          },
                        }
                      )
                    }
                  >
                    {row?.bookingId || "-"}
                  </td>
                  <td className="cursor_p">
                    <div
                      role="button"
                      tabIndex={0}
                      onClick={() =>
                        navigate(`/manage-customers/detail/${row?.userId}`, {
                          state: {
                            status: "APPROVED",
                            memberType: row?.memberShipType,
                          },
                        })
                      }
                    >
                      <div>{row?.name || "-"}</div>
                      <div style={{ fontSize: "12px", color: "#888" }}>
                        {row?.phoneNumber || "-"}
                      </div>
                    </div>
                  </td>
                  <td>{row?.totalGuest || "-"}</td>
                  <td>{row?.internalStatus || "-"}</td>
                  <td>{row?.employeeDetails?.[0]?.name || "-"}</td>
                  <td>{row?.userType || "-"}</td>
                  <td>AED {row?.amount ? row?.amount : "0"}</td>
                </tr>

                {/* {!isPast && expandedRowId === row.id && (
                    <tr>
                      <td colSpan={7}>
                        <div className="expanded-content">
                          <div className="form_flex booking_assign">
                            <div className="w_100">
                              <div className="control_group charge_field">
                                <h2>Assign To</h2>
                              </div>
                              <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={assignToMe}
                                      onChange={(e) => {
                                        setAssignToMe(e.target.checked);
                                        if (e.target.checked)
                                          setAssignToEmployee(false);
                                      }}
                                    />
                                  }
                                  label="Me"
                                />
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={assignToEmployee}
                                      onChange={(e) => {
                                        setAssignToEmployee(e.target.checked);
                                        if (e.target.checked)
                                          setAssignToMe(false);
                                      }}
                                    />
                                  }
                                  label="Employee"
                                />
                              </FormGroup>

                              {assignToEmployee && (
                                <Select
                                  value={Employee}
                                  onChange={handleChange1}
                                >
                                  <MenuItem value="0" disabled>
                                    Employee Listing
                                  </MenuItem>
                                  <MenuItem value="10">Employee 1</MenuItem>
                                  <MenuItem value="20">Employee 2</MenuItem>
                                  <MenuItem value="30">Employee 3</MenuItem>
                                </Select>
                              )}

                              <Select value={Status} onChange={handleChange2}>
                                <MenuItem value="0" disabled>
                                  Status
                                </MenuItem>
                                <MenuItem value="10">Status 1</MenuItem>
                                <MenuItem value="20">Status 2</MenuItem>
                                <MenuItem value="30">Status 3</MenuItem>
                              </Select>

                              <Button className="btn btn_primary">Save</Button>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  )} */}
              </React.Fragment>
            ))
          ) : (
            <tr>
              <td colSpan={7} style={{ textAlign: "center", padding: "20px" }}>
                No Data Found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default CutomerBookingTable;
